module.exports = __webpack_public_path__ + "img/8_heart.e991aabe.jpg";